'use strict'

addReferrer = (scope = '', query = {}) ->
  # the `referrer-link` class is added to any <a>
  # element requiring a return_to parameter in the href
  selector = '.referrer-link'

  Object.assign query, metric: 'layout_login'

  returnToValue = getCurrentUrl()

  $(selector, scope).each ->
    if customUrl = this.dataset.returnto
      # set a custom referral url is one has been specified as a data attribute
      referrer = customUrl
    else
      referrer = returnToValue

    params = Object.assign {}, query, return_to: referrer

    originalHref = @href
    if @getAttribute('data-href') # try to get the original href from data-href
      originalHref = @getAttribute('data-href')
    else
      @setAttribute('data-href', originalHref) # save the original href to data-href

    url = new URL originalHref
    for key, value of params
      url.searchParams.append key, value

    @href = url.toString()

###*
# Returns an encoded `return_to` parameter for a link URL
#
# @param   {String} url - The url to be added to the return_to param
# @returns {String}
###
getReturnQuery = (str) ->
  encodeURIComponent str

getCurrentUrl = ->
  url = new URL location.href
  url.hash = ''
  url.searchParams.delete('ref')
  url.searchParams.delete('return_to')
  # matches referrer parameter only and removes it
  url.toString()

# Get signin url with return_to query param for current page
getSigninUrl = ->
  currentUrl = getCurrentUrl()
  return "/login?return_to=#{getReturnQuery(currentUrl)}"

###
#  Adds current url as a referrer attribute to user session links
###
module.exports = {
  addReferrer
  getCurrentUrl
  getReturnQuery
  getSigninUrl
}
